import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import React from 'react';

const useStyles = makeStyles(theme => ({
  title: {
    marginBottom: theme.spacing(6),
    [theme.breakpoints.up('md')]: {
      maxWidth: '60%',
      marginRight: 'auto',
      marginBottom: theme.spacing(8),
      marginLeft: 'auto'
    },
    [theme.breakpoints.up('lg')]: {
      marginBottom: theme.spacing(14)
    }
  }
}));

const SectionTitle = ({ title, className, ...props }) => {
  const classes = useStyles();

  return (
    <>
      <Typography
        className={clsx(classes.title, className)}
        variant="h2"
        align="center"
        {...props}
      >
        {title}
      </Typography>
    </>
  );
};

SectionTitle.propTypes = {
  title: PropTypes.string.isRequired,
  className: PropTypes.string
};

SectionTitle.defaultProps = {
  className: ''
};

export default SectionTitle;
